import { createStore } from "vuex";

const store = createStore({
    state() {
        return {
            locale: document.documentElement.getAttribute("lang") ?? "ka",
            loading: false,
        };
    },
    mutations: {
        changeLoading(state, bool) {
            state.loading = bool;
        },
    },
});

export default store;
